export default __webpack_public_path__ + "static/media/mao.ccf1fff2.png";